import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "amfe-flexible";
import storage from "./common/utils/storage";
import "@/styles/base.scss";
import VueAMap from 'vue-amap';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

Vue.config.ignoredElements = ['wx-open-launch-weapp'];

import VuePageStack from 'vue-page-stack';
Vue.use(VuePageStack, { router });

import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '52dfd4bdee80a6f833539d79f5b4805d',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Marker'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

const acPlayerToolInit = window.acPlayerToolInit;
Vue.prototype.TCPlayer = acPlayerToolInit;

import Swiper2, { EffectFade, Navigation, Pagination, EffectCards, EffectCoverflow } from 'swiper'
Swiper2.use([EffectFade, Navigation, Pagination, EffectCards, EffectCoverflow]);
import VueAwesomeSwiper from "vue-awesome-swiper";
import 'swiper/swiper-bundle.css';
Vue.use(VueAwesomeSwiper);

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

import * as custom from './common/filters'
Object.keys(custom).forEach(key => { Vue.filter(key, custom[key]) });

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

axios.interceptors.request.use(
  config => {
    if (sessionStorage.getItem("Token")) {
      config.headers.common["token"] = sessionStorage.getItem("Token");
    }
    // config.headers.common["token"] = '654321';
    return config;
  },
  error => {
    console.log(error);
  }
);

axios.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.RetCode == '10000') {
      return res;
    }
    // else if (res.RetCode == '10001') {
    //   router.push('/login');
    // }
    else {
      return Promise.reject(new Error(res.RetMsg || 'Error'));
    }
  },
  error => {
    return Promise.reject(error);
  }
)

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
